import '../Styles/Projects.css';
import Project from './Project';

function Projects(props) {

  return (

    <div className="Projects">
      {props.projects.map(projectData =>
          <Project data={projectData.data()} key={projectData.id} id={projectData.id} />
      )}
    </div>

  );
}

export default Projects;